import {
  GET_EMPLOYMENT_STATUS_LIST,
  GET_EMPLOYMENT_STATUS_LIST_SUCCESS,
  GET_EMPLOYMENT_STATUS_LIST_ERROR,
  GET_OCCUPATION_CATEGORIES,
  GET_OCCUPATION_CATEGORIES_SUCCESS,
  GET_OCCUPATION_CATEGORIES_ERROR,
  GET_OCCUPATION_CATEGORY_INFO,
  GET_OCCUPATION_CATEGORY_INFO_SUCCESS,
  GET_OCCUPATION_CATEGORY_INFO_ERROR,
  GET_EMPLOYMENT_INFO,
  GET_EMPLOYMENT_INFO_SUCCESS,
  GET_EMPLOYMENT_INFO_ERROR,
  CREATE_EMPLOYMENT_INFO,
  CREATE_EMPLOYMENT_INFO_SUCCESS,
  CREATE_EMPLOYMENT_INFO_ERROR,
  UPDATE_EMPLOYMENT_INFO,
  UPDATE_EMPLOYMENT_INFO_SUCCESS,
  UPDATE_EMPLOYMENT_INFO_ERROR,
  GET_INCOME_SOURCE_LIST,
  GET_INCOME_SOURCE_LIST_SUCCESS,
  GET_INCOME_SOURCE_LIST_ERROR,
} from './employmentStatusActionConstants';

export const getEmploymentStatusList = (payload) => ({
  type: GET_EMPLOYMENT_STATUS_LIST,
  payload,
});

export const getEmploymentStatusListSuccess = (payload) => ({
  type: GET_EMPLOYMENT_STATUS_LIST_SUCCESS,
  payload,
});

export const getEmploymentStatusListError = (payload) => ({
  type: GET_EMPLOYMENT_STATUS_LIST_ERROR,
  payload,
});

export const getOccupationCategories = (payload) => ({
  type: GET_OCCUPATION_CATEGORIES,
  payload,
});

export const getOccupationCategoriesSuccess = (payload) => ({
  type: GET_OCCUPATION_CATEGORIES_SUCCESS,
  payload,
});

export const getOccupationCategoriesError = (payload) => ({
  type: GET_OCCUPATION_CATEGORIES_ERROR,
  payload,
});

export const getOccupationCategory = (payload) => ({
  type: GET_OCCUPATION_CATEGORY_INFO,
  payload,
});

export const getOccupationCategorySuccess = (payload) => ({
  type: GET_OCCUPATION_CATEGORY_INFO_SUCCESS,
  payload,
});

export const getOccupationCategoryError = (payload) => ({
  type: GET_OCCUPATION_CATEGORY_INFO_ERROR,
  payload,
});

export const getEmploymentInfo = (payload) => ({
  type: GET_EMPLOYMENT_INFO,
  payload,
});

export const getEmploymentInfoSuccess = (payload) => ({
  type: GET_EMPLOYMENT_INFO_SUCCESS,
  payload,
});

export const getEmploymentInfoError = (payload) => ({
  type: GET_EMPLOYMENT_INFO_ERROR,
  payload,
});

export const createEmploymentInfo = (payload) => ({
  type: CREATE_EMPLOYMENT_INFO,
  payload,
});

export const postEmploymentInfoSuccess = (payload) => ({
  type: CREATE_EMPLOYMENT_INFO_SUCCESS,
  payload,
});

export const postEmploymentInfoError = (payload) => ({
  type: CREATE_EMPLOYMENT_INFO_ERROR,
  payload,
});

export const updateEmploymentInfo = (payload) => ({
  type: UPDATE_EMPLOYMENT_INFO,
  payload,
});

export const putEmploymentInfoSuccess = (payload) => ({
  type: UPDATE_EMPLOYMENT_INFO_SUCCESS,
  payload,
});

export const putEmploymentInfoError = (payload) => ({
  type: UPDATE_EMPLOYMENT_INFO_ERROR,
  payload,
});

export const getIncomeSourceList = (payload) => ({
  type: GET_INCOME_SOURCE_LIST,
  payload,
});

export const getIncomeSourceListSuccess = (payload) => ({
  type: GET_INCOME_SOURCE_LIST_SUCCESS,
  payload,
});

export const getIncomeSourceListError = (payload) => ({
  type: GET_INCOME_SOURCE_LIST_ERROR,
  payload,
});
